import { Loader2, Search, X } from "lucide-react";

export const SearchInput = ({ value, onChange, isSearching }) => {
  return (
    <div className="relative flex-1 max-w-sm">
      <input
        onChange={onChange}
        value={value}
        type="text"
        placeholder="Rechercher un element..."
        className="input input-bordered px-3 pl-10 pr-10 w-full h-11 text-sm text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-white"
      />
      <Search className="w-4 h-4 absolute left-3 top-3.5 text-gray-400" />
      {isSearching && (
        <Loader2 className="w-4 h-4 animate-spin absolute right-3 top-3.5 text-amber-500" />
      )}
      {value && !isSearching && (
        <button className="absolute right-3 top-3.5 text-gray-400 hover:text-gray-600">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
